module.exports = __webpack_public_path__ + "static/media/report-bath-icon.e540e190.svg";